module.exports = __webpack_public_path__ + "static/media/venom-static.5f6e6725.png";